<template>
    <el-dialog
        :title="setId?'编辑小区':'新增小区'"
        :visible.sync="communityDialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        width="600px"
        center>
        <el-form :model="communityForm" :rules="rules" ref="communityForm" label-width="100px">
            <el-form-item label="社区名称" prop="xiangmuId">
                <el-select v-model="communityForm.xiangmuId" placeholder="请选择社区" style="width: 100%;" v-if="user.power === 3" @change="projectChange">
                    <el-option
                        v-for="item in projectList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
                <el-input :value="communityForm.xiangmuName" readonly placeholder="请选择社区" v-else></el-input>
            </el-form-item>
            <el-form-item label="小区名称" prop="name">
                <el-input v-model="communityForm.name" placeholder="请输入小区名称"></el-input>
            </el-form-item>
            <el-form-item label="小区地区" prop="region">
                <el-cascader
                    style="width: 100%;"
                    expand-trigger="hover"
                    filterable
                    placeholder="请选择小区地区"
                    :options="options"
                    v-model="communityForm.region"
                    @change="addressChange"
                >
                </el-cascader>
            </el-form-item>
            <el-form-item label="详细地址" prop="address">
                <el-input v-model="communityForm.address" placeholder="请输入详细地址"></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="beizhu">
                <el-input type="textarea" v-model="communityForm.beizhu" placeholder="请输入备注"></el-input>
            </el-form-item>
            <el-form-item class="flex align-center justify-around" label-width="0">
                <el-button class="padding-lr-xl" @click="resetForm('communityForm')">取消</el-button>
                <el-button class="padding-lr-xl" type="primary" @click="submitForm('communityForm')">提交</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
import {CodeToText, regionData} from "element-china-area-data";
import {xiangMuByXiangMuJingLi, xiaoQuAdd} from "@/api/community";
import {getXiangMuList} from "@/api/common";

export default {
    name: "communityDialog",
    props: {
        communityDialog: {
            type: Boolean,
            default: false
        },
        setId: {
            type: Number,
            default() {
                return 0;
            }
        },
        setItem: {
            type: Object
        }
    },
    data() {
        return {
            options: regionData,
            projectList: [],
            communityForm: {
                xiangmuId: '',
                xiangmuName: '',
                name: '',
                region: [],
                region_text: [],
                address: '',
                beizhu: '',
            },
            rules: {
                xiangmuId: [{required: true, message: '请选择社区', trigger: 'change'}],
                name: [{required: true, message: '请输入小区名称', trigger: 'blur'}],
                region: [{required: true, message: '请选择小区地区', trigger: 'change'}],
                address: [{required: true, message: '请输入详细地址', trigger: 'blur'}],
            }
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    created() {
        if (this.user.power === 3)this.getXiangMuList()
        else this.xiangMuByXiangMuJingLi()
    },
    methods: {
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.$emit('cancelDialog', false)
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitData(formName)
                }
            });
        },
        async submitData(formName) {
            let _state = await xiaoQuAdd(
                this.communityForm.xiangmuId,
                this.communityForm.name,
                this.communityForm.region[0],
                this.communityForm.region_text[0],
                this.communityForm.region[1],
                this.communityForm.region_text[1],
                this.communityForm.region[2],
                this.communityForm.region_text[2],
                this.communityForm.address,
                this.communityForm.beizhu,
                this.setId ? this.setId : '',
            );
            this.$message.success(_state.info);
            this.$refs[formName].resetFields();
            this.$emit("cancelDialog", true);
        },
        //  根据地址code 换取 地址Zh
        addressChange(arr) {
            this.communityForm.region = arr;
            this.communityForm.region_text = [CodeToText[arr[0]], CodeToText[arr[1]], CodeToText[arr[2]]];
        },
        //  获取小区经理电话
        setPhone(val) {
            let _item = this.xmhlList.filter(item => item.id === val)
            this.communityForm.phone = _item[0].username
        },
        projectChange(e) {
            this.communityForm.xiangmuId = e
        },
        async getXiangMuList() {
            let _data = await getXiangMuList()
            this.projectList = _data.data
        },
        //  获取小区经理
        async xiangMuByXiangMuJingLi() {
            let _list = await xiangMuByXiangMuJingLi()
            this.communityForm.xiangmuId = _list.data.id
            this.communityForm.xiangmuName = _list.data.name
        }
    },
    watch: {
        setItem() {
            this.communityForm = {
                name: this.setItem.name,
                xiangmuId: this.user.power === 3 ? this.setItem.xiangmu_id :this.communityForm.xiangmuId ,
                xiangmuName: this.user.power === 3 ? this.setItem.xiangmu_name : this.communityForm.xiangmuName,
                region: this.setItem.sheng_id ? [this.setItem.sheng_id.toString(), this.setItem.shi_id.toString(), this.setItem.xian_id.toString()] : [],
                region_text: this.setItem.sheng_name ? [this.setItem.sheng_name, this.setItem.shi_name, this.setItem.xian_name] : [],
                address: this.setItem.address,
                beizhu: this.setItem.beizhu
            };
        }
    }
}
</script>

<style scoped lang="scss">

</style>
